import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { ScreenFlyout } from "../ScreenFlyout/ScreenFlyout";
import { ScreenMenu } from "../ScreenMenu/ScreenMenu";
import { ScreenMenuOpenButton } from "../ScreenMenuOpenButton/ScreenMenuOpenButton";
import { ScreenContent } from "./ScreenContent";

export type ScreenProps = {
  screen: SliceWallScreenState;
};

export function Screen({ screen }: ScreenProps) {
  if (!screen.active) {
    return null;
  }

  return (
    <div className="relative w-full h-full">
      <ScreenContent screen={screen} />
      <ScreenFlyout screen={screen} />
      <ScreenMenu screen={screen} />
      <ScreenMenuOpenButton screen={screen} />
    </div>
  );
}
